document.addEventListener("DOMContentLoaded", () => {
    const timerContainer = document.querySelector("promo-timer");
    const tabButtons = timerContainer.querySelectorAll(".promo-timer__btn");
    const tabs = timerContainer.querySelectorAll(".promo-timer__tab");
    const playButton = timerContainer.querySelector(".promo-timer__play-btn");
    const restartButton = timerContainer.querySelector(".promo-timer__restart-btn");
    let activeTabIndex = 1;
    let countdown;
    let isRunning = false;
    let remainingTime = null;
    const originalTitle = document.title;

    function switchTab(index) {
        tabButtons.forEach(btn => btn.classList.remove("active"));
        tabs.forEach(tab => tab.classList.remove("active"));
        
        const activeBtn = timerContainer.querySelector(`.promo-timer__btn[data-tab-index="${index}"]`);
        const activeTab = timerContainer.querySelector(`.promo-timer__tab[data-tab-index="${index}"]`);
        
        if (activeBtn && activeTab) {
            activeBtn.classList.add("active");
            activeTab.classList.add("active");
            activeTabIndex = index;
        }
        resetTimers();
        document.title = originalTitle;
    }

    function startTimer() {
        const activeTimer = timerContainer.querySelector(`.promo-timer__tab.active .promo-timer__timer-time`);
        
        if (isRunning) {
            clearInterval(countdown);
            isRunning = false;
            playButton.textContent = "Start";
            document.title = originalTitle;
            return;
        }
        
        if (remainingTime === null) {
            remainingTime = activeTimer.getAttribute("data-minutes-count") * 60;
        }
        
        playButton.textContent = "Pause";
        isRunning = true;

        countdown = setInterval(() => {
            if (remainingTime <= 0) {
                clearInterval(countdown);
                playButton.textContent = "Start";
                isRunning = false;
                remainingTime = null;
                document.title = originalTitle;
                return;
            }
            remainingTime--;
            const minutes = Math.floor(remainingTime / 60).toString().padStart(2, "0");
            const seconds = (remainingTime % 60).toString().padStart(2, "0");
            activeTimer.textContent = `${minutes}:${seconds}`;
            document.title = `${minutes}:${seconds} - ${originalTitle}`;
        }, 1000);
    }

    function resetTimers(keepActive = null) {
        clearInterval(countdown);
        isRunning = false;
        playButton.textContent = "Start";
        document.title = originalTitle;
        remainingTime = null;
        
        tabs.forEach(tab => {
            const timerElement = tab.querySelector(".promo-timer__timer-time");
            const defaultTime = timerElement.getAttribute("data-minutes-count");
            if (!keepActive || tab.dataset.tabIndex !== keepActive.toString()) {
                timerElement.textContent = `${defaultTime}:00`;
            }
        });
    }

    tabButtons.forEach(button => {
        button.addEventListener("click", () => {
            switchTab(button.getAttribute("data-tab-index"));
        });
    });

    playButton.addEventListener("click", startTimer);
    restartButton.addEventListener("click", () => resetTimers());

    // Set initial active tab
    switchTab(activeTabIndex);
});
